/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import styled from 'styled-components';

const _getCursor = (props: any) => {
    const cursor = props.structureLocked
        ? 'not-allowed'
        : !props.currBlockIsSelected
        ? 'initial'
        : props.isDragging
        ? 'grabbing'
        : 'grab';
    return cursor;
};

interface IProps {
    isDragging: boolean;
    cursorSource: string;
    structureLocked: boolean;
    wrapperBackgroundColor: string;
    width: number | string;
    paddingTop: number | string;
    paddingBottom: number | string;
    backgroundColor: string;
    bodyBackgroundColor: string;
}

export const CanvasBlock = styled.div<IProps>((props) => ({
    opacity: props.isDragging ? 0.25 : 1,
    position: 'relative',
    cursor: _getCursor(props),
}));

export const CanvasBlockContentWrapper = styled.div<IProps>`
    display: block;
    pointer-events: ${(props) => (props.structureLocked ? 'none' : 'initial')};
    z-index: 1;
`;

export const CanvasBlockWrapper = styled.div<IProps>`
    background-color: ${(props) =>
        props.wrapperBackgroundColor ? props.wrapperBackgroundColor : props.bodyBackgroundColor};
    z-index: 0;
`;

export const BlockContentDiv = styled.div<IProps>`
    margin: 0 auto;
    width: ${(props) => props.width}px;
    padding: ${(props) => props.paddingTop}px 0 ${(props) => props.paddingBottom}px;
    background-color: ${(props) => props.backgroundColor};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const ColumnWrapper = styled.div`
    position: relative;
    flex: 0 0 auto;
    vertical-align: top;
`;

export const LockIconsWrapper = styled.div`
    position: absolute;
    top: 2px;
    left: 2px;
    z-index: 2;
`;

export const LockButtons = styled.div`
    display: inline-block;
    padding: 0;
`;

export const LockIconsDiv = styled.div`
    margin: 0;
    padding: 2px;
    width: 18px;
    height: 20px;
    background: rgba(255, 255, 255, 0.5);
`;

interface IIconProps {
    disabled: boolean;
    isDelete: boolean;
}

export const Icon = styled.i<IIconProps>`
    font-size: 18px;
    cursor: pointer;
    color: ${({ disabled, theme }) => (disabled ? theme.colors.neutral100 : theme.colors.neutral700)};
    ${({ disabled, isDelete, theme }) =>
        !disabled &&
        `
        :hover {
            color: ${isDelete ? theme.colors.danger300 : theme.colors.neutral700};
        }`}
`;

export const ControlsWrapper = styled.div`
    height: 32px;
    width: 100%;
    position: absolute;
`;

export const CheckboxLabel = styled.label`
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: 700;
    font-size: 10px;
    line-height: 18px;
    text-align: center;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #1c1c1c;
`;

interface ICheckboxTextProps {
    isVisible: boolean;
}

export const CheckboxText = styled.span<ICheckboxTextProps>`
    display: ${({ isVisible }) => (isVisible ? 'inherit' : 'none')};
    height: 22px;
    padding-top: 2px;
    padding-right: 4px;
    background: rgba(255, 255, 255, 0.5);
`;

export const Button = styled.div`
    display: inline-block;
    padding: 2px;
    height: 20px;
    background: rgba(255, 255, 255, 0.5);
    cursor: pointer;
`;

export const CheckboxIconsWrapper = styled.div`
    position: absolute;
    top: 2px;
    left: 24px;
    z-index: 2;
`;

export const CheckboxIcon = styled(Icon)`
    font-weight: bold;
    color: black;
`;

export const RightControls = styled.div`
    display: flex;
    justify-content: space-between;
    width: 90px;
    position: absolute;
    top: 7px;
    right: 5px;
    z-index: 2;
`;

interface IDropZoneProps {
    isOverBlock?: boolean;
    isOverCurrent?: boolean;
}

export const DropZoneDiv = styled.div<IDropZoneProps>(({ isOverBlock }) => ({
    height: isOverBlock ? '80px' : '0px',
    width: '100%',
    backgroundColor: 'none',
    opacity: 0.5,
    margin: 0,
    zIndex: 10,
    top: -40,
    position: 'absolute',
}));

export const DropZoneHighlighter = styled.div<IDropZoneProps>(({ theme, isOverBlock, isOverCurrent }) => ({
    height: isOverBlock ? 3 : 0,
    opacity: isOverBlock ? '1' : '0',
    transition: 'height 0.1s linear',
    '-webkit-transition': 'height 0.1s linear',
    margin: 0,
    backgroundColor: isOverCurrent ? theme.colors.primary700 : theme.colors.primary300,
}));

export const DropZoneText = styled.p`
    font-size: 13px;
    color: black;
    font-weight: bold;
    background: white;
    width: 120px;
    height: 20px;
    left: calc(50% - 60px);
    top: calc(50% - 10px);
    text-align: center;
    position: absolute;
`;

export const LoaderWrapper = styled.div<IProps>`
    border: 1px dashed #bfc8d0;
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ width }) => (width ? `width: ${width}px` : 'flex-grow: 1')};
    height: 100px;
    margin: 4px;
`;
